import {ChangeDetectionStrategy, Component, computed, effect, inject, PLATFORM_ID} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MainMenu} from './components/main-menu/main-menu';
import {ClippyChat} from '@frednh/ai-agentic-core';
import {AuthService} from './services/auth-service';
import {environment} from '../environments/environment';
import {RouterOutlet} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {NotificationService} from '@frednh/ai-agentic-core';
import {I18nService} from './services/i18n-service';
import {CrmNotificationRefreshService} from './services/crm-notification-refresh-service';
import {RouterMarkdownLinksDirective} from './shared/router-markdown-links.directive';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    MatButton,
    ClippyChat,
    MainMenu,
    RouterOutlet,
    RouterMarkdownLinksDirective,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly title = computed(() => this.i18n.t('app.title'));

  constructor(
    protected authService: AuthService,
    protected readonly i18n : I18nService,
    private readonly notificationService: NotificationService,
    private readonly crmNotificationRefreshService: CrmNotificationRefreshService
  ) {
    void this.crmNotificationRefreshService;
    this.authService.initializeCurrentUser();

    if (isPlatformBrowser(this.platformId)) {
      effect(() => {
        const user = this.authService.currentUser();

        if (user?.id) {
          console.log('Connecting to notifications stream for user', user.id);
          this.notificationService.connect(user.id, environment.apiUrl + '/notifications/stream');
        } else {
          this.notificationService.disconnect();
        }
      });
    }
  }
}
